/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Active_Message_RequiredInputs */

const en_carrier_notices_active_message_required = /** @type {(inputs: Carrier_Notices_Active_Message_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active carrier notices require a message.`)
};

const es_carrier_notices_active_message_required = /** @type {(inputs: Carrier_Notices_Active_Message_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los avisos activos requieren un mensaje.`)
};

/**
* | output |
* | --- |
* | "Active carrier notices require a message." |
*
* @param {Carrier_Notices_Active_Message_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_active_message_required = /** @type {((inputs?: Carrier_Notices_Active_Message_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Active_Message_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_active_message_required(inputs)
	return es_carrier_notices_active_message_required(inputs)
});